export const eventPageNavigation = `<svg viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="4.19634" cy="22.0527" r="3" transform="rotate(36.5213 4.19634 22.0527)" fill="currentColor"/>
<circle cx="10.7427" cy="13.2124" r="3" transform="rotate(36.5213 10.7427 13.2124)" fill="currentColor"/>
<circle cx="19.5831" cy="19.7593" r="3" transform="rotate(36.5213 19.5831 19.7593)" fill="currentColor"/>
<circle cx="26.129" cy="10.9194" r="3" transform="rotate(36.5213 26.129 10.9194)" fill="currentColor"/>
<path d="M4.29494 22.2822L10.666 13.2318L19.7164 19.6029L25.9437 11.0314" stroke="currentColor" stroke-width="2"/>
</svg>`;
